import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=1ad28922"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports